import UserProfileClient from "../lib/apiClients/roofSnapApiClient/userProfileClient";
import QueryStringBuilder from "../lib/queryStringBuilder";
import { CALL_API } from "../middleware/api";
import {
    GET_USER_PROFILES_FAILURE,
    GET_USER_PROFILES_REQUEST,
    GET_USER_PROFILES_SUCCESS
} from "./actionTypes";

export const getUserProfiles = (page = 1, searchValue, organizationId, userRoleIds) => {
    const userProfileClient = new UserProfileClient('v1');
    const request = userProfileClient.getUserProfiles;

    const queryStringBuilder = new QueryStringBuilder();
    queryStringBuilder.setQueryParameter('page', page);
    if (searchValue) {
        queryStringBuilder.setQueryParameter('search', searchValue);
    }
    if (organizationId) {
        queryStringBuilder.setQueryParameter('organizationId', organizationId);
    }
    if (userRoleIds) {
        userRoleIds.forEach(roleId => {
            queryStringBuilder.setQueryParameter('userRoleIds', roleId);
        });
    }

    const queryParams =  queryStringBuilder.buildQueryString();

    return {
        [CALL_API]: {
            types: [
                GET_USER_PROFILES_REQUEST,
                GET_USER_PROFILES_SUCCESS,
                GET_USER_PROFILES_FAILURE
            ],
            request,
            params: {
                queryParams,
            }
        }
    }
};
